export interface INavigationState {
  storedCourses: Record<string, { lastNode: string | null }> | null;
}

export const NavigationInitialState: INavigationState = {
  storedCourses: null
};
